export enum CookieCategories {
  Performance = "C0002", // OneTrust category ID for performance/analytics cookies
}

export const getAllowedCookieCategories = (): string =>
  (window as Window & { OnetrustActiveGroups?: string }).OnetrustActiveGroups ?? ""

export const hasPerformanceCookieConsent = (): boolean => {
  return getAllowedCookieCategories().includes(CookieCategories.Performance)
}
